// extracted by mini-css-extract-plugin
module.exports = {"body":"Style_body__2CLXO","iconWrapper":"Style_iconWrapper__Kx5rt","closeButton":"Style_closeButton__23tzO"};